import React from 'react';
import Hero from './Hero';
import Features from './Features';
import Testimonials from './Testimonials';

function Home() {
  return (
    <div className=" min-h-screen">
      <Hero />
      <Features />
      <Testimonials />
    </div>
  );
}

export default Home;